import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const ArtistPage = lazy (() => import ('@/pages/user/artist/ArtistPage.tsx'))
const ArtistDetailPage = lazy(() =>  import  ('@/pages/user/artist/ArtistDetailPage.tsx'))
const ArtistAddPage = lazy(() => import ('@/pages/user/artist/ArtistAddPage.tsx'))
const UserPage = lazy(()=> import ('@/pages/user/user/UserPage.tsx'))
const UserDetailPage = lazy(()=> import ('@/pages/user/user/UserDetailPage.tsx'))

/**
 * 사용자 관리 라우트
 * - 아티스트
 * - 유저
 */
export const memberRoutes: RouteWithMeta = {
  path: 'members',
  meta: {
    label: '사용자',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 아티스트 =====
    {
      path: 'artist',
      element: withSuspense(<ArtistPage/>),
      meta: {
        label: '아티스트',
        showInMenu: true,
      }
    },
    {
      path: 'artist/add',
      element: withSuspense(<ArtistAddPage/>),
      meta: {
        label: '아티스트 등록',
        showInMenu: false,
      }
    },
    {
      path: 'artist/:id',
      element: withSuspense(<ArtistDetailPage/>),
      meta: {
        label: '아티스트 상세',
        showInMenu: false
      }
    },

    // ===== 유저 =====
    {
      path: 'user',
      element: withSuspense(<UserPage/>),
      meta: {
        label: '유저',
        showInMenu: true,
      }
    },
    {
      path: 'user/:id',
      element: withSuspense(<UserDetailPage/>),
      meta: {
        label: '유저 상세',
        showInMenu: false
      }
    },
  ]
}